import { Helmet } from 'react-helmet';
import LoginFormAuth0 from './LoginFormAuth0';

export default function LoginPageAuth0() {
  return (
    <>
      <Helmet>
        <title>Log In | LocaliQ</title>
      </Helmet>
      <LoginFormAuth0 />
    </>
  );
}
